module.exports = __webpack_public_path__ + "mainassets/img/envelope-open.fcea2729.svg";